import { api as notificationApi } from './auto-generated/notification'

notificationApi.enhanceEndpoints({
  endpoints: {},
})

export { notificationApi }
